import { ICompany } from 'src/app/company/models/company';

/**
 * Companies that may appear in the inventory customer dropdowns: only those with the inventory
 * extension enabled. `keepCompanyId` keeps a specific company (e.g. the one an existing inventory
 * device belongs to) in the list even when its extension has been disabled in the meantime, so a
 * read-only dropdown still shows its name.
 */
export function companiesWithInventory(companies: ICompany[], keepCompanyId?: string): ICompany[] {
  return (companies ?? []).filter(company => company.inventoryEnabled === true || (keepCompanyId != null && company.id === keepCompanyId));
}
